import appConstants from '../../../../../../constants';
import { KEYS } from '../../../../../../l18n/constants';
import { useL18nContext } from '../../../../ContextProvider/L18n';
import computeClassName from '../../../../../../utils/computeClassName';
import PartnerProfileOverviewAttributeListSection from './AttributeListSection';

const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-secondary text-cc-secondary-contrast py-12 sm:py-20'
});

function getComputedListItemSectionClassName(sectionIndex) {
  return sectionIndex === 0 ?
    'pt-6' :
    'border-t border-cc-gray-05 pt-6';

}

export default function PartnerProfileOverview(
  {
    partnerName,
    partnerDescription,
    partnerRoles,
    partnerTechnologies,
    partnerIndustries,
    isDiversePartner,
    partnerDiversityProgramNames,
    className = ''
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();

  let attributeListSections = [
    {
      [appConstants.KEY_ATTRIBUTE_LIST_TITLE]: getTranslationFor(KEYS.L18N_KEY_LABEL_ROLES),
      [appConstants.KEY_ATTRIBUTE_LIST_ITEMS]: partnerRoles,
      [appConstants.KEY_USE_GRID_DISPLAY]: true,
    },
    {
      [appConstants.KEY_ATTRIBUTE_LIST_TITLE]: getTranslationFor(KEYS.L18N_KEY_LABEL_TECHNOLOGY),
      [appConstants.KEY_ATTRIBUTE_LIST_ITEMS]: partnerTechnologies,
      [appConstants.KEY_USE_GRID_DISPLAY]: true,
    },
    {
      [appConstants.KEY_ATTRIBUTE_LIST_TITLE]: getTranslationFor(KEYS.L18N_KEY_LABEL_INDUSTRIES),
      [appConstants.KEY_ATTRIBUTE_LIST_ITEMS]: partnerIndustries,
      [appConstants.KEY_USE_GRID_DISPLAY]: true,
    },
    {
      [appConstants.KEY_ATTRIBUTE_LIST_TITLE]: getTranslationFor(KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER),
      [appConstants.KEY_ATTRIBUTE_LIST_ITEMS]: partnerDiversityProgramNames,
      [appConstants.KEY_USE_GRID_DISPLAY]: false
    }
  ];

  const translatedLabelAbout = getTranslationFor(KEYS.L18N_KEY_LABEL_ABOUT,'About','About');
  return (
    <section id="overview" className={computedClassName}>
      <header className="px-10 xs:px-0 xs:mx-auto xs:w-7/12 pb-6">
        <h2 className="text-cc-300 mb-3">{translatedLabelAbout} {partnerName}</h2>
        <p className="">{partnerDescription}</p>
      </header>
      {
        attributeListSections.map((attributeListSection, index) => {
          const computedListItemSectionClassName = getComputedListItemSectionClassName(index);
          return <PartnerProfileOverviewAttributeListSection className={computedListItemSectionClassName}
                                                             key={index}
                                                             sectionTitle={attributeListSection[appConstants.KEY_ATTRIBUTE_LIST_TITLE]}
                                                             attributeList={attributeListSection[appConstants.KEY_ATTRIBUTE_LIST_ITEMS]}
                                                             useGridDisplay={attributeListSection[appConstants.KEY_USE_GRID_DISPLAY]}/>
        })
      }
    </section>
  );
}
